module.exports = __webpack_public_path__ + "static/img/0000个人网站2.ae2cec0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0000个人网站2.jpg
// module id = NoJF
// module chunks = 0